import type { AlertSeverity } from '../review/schema';

/** Spanish text for each alert severity - shown beside the badge's color, never as color alone
 * (Phase 6 rule: "never encode risk by color alone"), matching `history/StatusBadge.tsx`'s same
 * convention for note statuses. */
export const SEVERITY_LABELS: Readonly<Record<AlertSeverity, string>> = {
  info: 'Información',
  warning: 'Advertencia',
  error: 'Error',
};
